module.exports = __webpack_public_path__ + "static/newCoursesBackground-025cd2b277e2f2cb68b41b7105f0f82c.jpg";